import CommunicationPreferencesDialog from '~/components/communicationPreferences/CommunicationPreferencesDialog.vue'
import {
	DialogController,
	PredefinedDialog,
	PredefinedDialogType,
} from '~/components/passporterUi/Dialog/dialogController'
import { ProfileService } from '~/passporter-services/profile/service'
import EventsService from '~/services/events'
import { TranslationService } from '~/services/Translation'
import { useProfileStore } from '~/store/profile'

export default class CommunicationPreferencesAction {
	static createDialog(): DialogController {
		const dialog = new PredefinedDialog(PredefinedDialogType.EMPTY, CommunicationPreferencesDialog)
			.title(TranslationService.getInstance().translate('menu_communicationPreferences'))
			.size('s')
			.mobileType('fullScreen')
		return new DialogController(dialog.build())
	}

	static async changeNewsPreferences(
		profileId: string,
		consentCommercialComunications: boolean
	): Promise<void> {
		const translation: TranslationService = TranslationService.getInstance()
		try {
			const profile = await ProfileService.updateProfile(profileId, {
				consentCommercialCommunications: consentCommercialComunications,
			})
			this.profileStore.setProfile(profile)
			EventsService.emitSuccess(translation.translate('feedback_preferencesUpdated'))
		} catch {
			EventsService.emitError(translation.translate('errorFeedback_preferencesUpdated'))
		}
	}

	private static get profileStore() {
		return useProfileStore()
	}
}
